import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { storeUser } from "../../Redux/Slice/authSlice";
import { Decryptedid } from "../../Util/BcruptEncyptid";

const PrivatedAuthRoutes = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const localStorageToken = localStorage.getItem("token");
  const authToken = useSelector(
    (state) => state?.authSlice.userData?.payload?.token
  );

  useEffect(() => {
    if (!localStorageToken) {
      dispatch(storeUser({}));
    }
  }, [localStorageToken, dispatch]);

  // Check for redirects
  if (location.pathname.includes("/shared-collection/student/")) {
    const id = location.pathname.split("/shared-collection/student/")[1];
    let idval = id;
    try {
      idval = Decryptedid(atob(id));
      if (!idval || idval.trim() === "") idval = id;
    } catch (error) {
      idval = id;
    }
    window.location.replace(
      `https://peerscroller.onelink.me/gTJq/fydlv6xg?collectionId=${id}&af_force_deeplink=true`
    );
    return null;
  }

  if (location.pathname.includes("/VideoShorts/")) {
    const decodedSearch = location.search.replace(/&amp;/g, "&");
    const urlParams = new URLSearchParams(decodedSearch);
    const role = urlParams.get("role");
    const isShareable = urlParams.get("isShareable");

    if (isShareable === "true" && role === "student") {
      const pathSegments = location.pathname.split("/");
      const videoId = pathSegments[pathSegments.length - 1];
      window.location.replace(
        `https://peerscroller.onelink.me/gTJq/fydlv6xg?videoId=${videoId}&af_force_deeplink=true`
      );
      return null;
    }
  }

  return authToken ? (
    <Outlet />
  ) : (
    <Navigate
      to="/"
      state={location.pathname === "/settings" ? {} : { from: location }}
      replace
    />
  );
};

export default PrivatedAuthRoutes;
